<template>
  <div>
    <v-card class="permissions-dialog" elevation="8">
      <v-card-title class="dialog-title">
        <h4 class="text-h5 font-weight-semibold">Default Permissions</h4>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text class="dialog-content">
        <v-container container--fluid grid-list-md>
          <v-row justify="center">
            <v-select label="Select a region..."
                      :items="regions"
                      return-object
                      item-text="name"
                      v-model="region"
            ></v-select>

            <v-col cols="12">
              <v-card>
                <v-list v-if="region">
                  <v-list-item
                    v-for="(permission, index) in renderedClientPermissions"
                    :key="index"
                  >
                    <v-list-item-action>
                      <v-checkbox @change="tickOrUntickPermission(permission)" v-model="permission.selected"
                      ></v-checkbox>
                    </v-list-item-action>
                    <v-list-item-title>{{permission.display}}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions class="dialog-actions">
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
    import axios from 'axios'

    // @group EditClient
    // Table to edit client pricings on EditClientPage
    export default {
        name: "ClientPermissions",
        props: {
            // Array of permissions of the client
            clientPermissions: Array,
            // Function that toggles dialog in which are the permissions
            toggleDialog: Function,
            // Client_id (number)
            id: Number,
        },
        data() {
            return {
                regions: [{id: 0, name: "Global"}],
                region: {id: 0, name: "Global"},
            }
        },
        methods: {
            tickOrUntickPermission(permission) {
                // New (unsaved) client: buffer the selection locally. The ticked
                // permissions are sent to the backend as part of the create
                // payload once the client is saved.
                if (!this.id) {
                    const index = this.clientPermissions.findIndex((el) => el.id === permission.id);
                    if (permission.selected && index === -1) {
                        this.clientPermissions.push(permission);
                    } else if (!permission.selected && index !== -1) {
                        this.clientPermissions.splice(index, 1);
                    }
                    return;
                }
                if (permission.selected) {
                    // Tick
                    axios.post(process.env.API_URL + '/clients/' + this.id + '/regions/' + this.region.id + '/permissions/' + permission.id)
                        .then((response) => {
                        })
                        .catch((response) => {
                            permission.selected = !permission.selected;
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                } else {
                    // Untick
                    axios.delete(process.env.API_URL + '/clients/' + this.id + '/regions/' + this.region.id + '/permissions/' + permission.id)
                        .then((response) => {
                        })
                        .catch((response) => {
                            permission.selected = !permission.selected;
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                }
            }
        },
        computed: {
            // @vuese
            // Rendered permissions array that will be displayed in the list
            // @type Array
            renderedClientPermissions() {
                if (this.allPermissions === undefined || this.allPermissions === null) return [];
                return Object.values(this.allPermissions.map((item) => {
                    item.selected = this.clientPermissions.find((el) => {
                        return el.id === item.id;
                    });
                    return item;
                })).sort((a, b) => (a.name > b.name) ? 1 : -1);
            },
        },
        asyncComputed: {
            async allPermissions() {
                return await axios.get(process.env.API_URL + '/users/permissions')
                    .then((response) => {
                        if (response.status === 200) {
                            return response.data;
                        } else return [];
                    })
                    .catch((error) => {
                        return [];
                    });
            }
        }
    }
</script>

<style scoped>
.permissions-dialog {
  border-radius: 8px;
}

.dialog-title {
  padding: 32px 32px 16px;
  display: flex;
  align-items: center;
}

.dialog-title h4 {
  margin: 0;
  color: #1A1A1A;
}

.dialog-content {
  padding: 24px 32px;
}

.dialog-actions {
  padding: 16px 32px 32px;
  justify-content: flex-end;
  gap: 16px;
}

.dialog-actions .v-btn {
  text-transform: none;
  font-weight: 600;
  min-width: 100px;
  height: 44px;
}
</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientPermissions.vue